<template>
    <icon :style="{ fill: iconColor }"></icon>
</template>

<script>
    export default {
        name: "base-icon",

        props: {
            color: {
                type: String,
                default: 'currentColor'
            }
        },

        computed: {
            iconColor() {
                return this.color || window.getComputedStyle(this.$el).color;
            }
        }
    }
</script>

<style scoped>

</style>

